import * as angular from "angular";
import {RuleEngineRequestsService} from "./services/rule-engine-requests.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {$ruleFactory} from "./$rule.factory";
import {SettingsService} from "../site-preferences/services/settings-service.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";

angular
  .module('bringoz.admin.ruleEngine')
  .config(RuleEngineConfig);


function RuleEngineConfig($stateProvider) {

  $stateProvider
    .state('rules', {
      parent: 'bringoz.site',
      url: '/rules',
      abstract: true,
      template: '<ui-view>'
    })
    // Rules
    .state('rules.table', {
      url: '/table?:from&:to&:dateRangeTemplateType',
      controllerAs: 'vm',
      reloadOnSearch: false,
      template: '<rules-view></rules-view>',
      controller: function (triBreadcrumbsService, viewFilterSettingsService: ViewFilterSettingsService,
                            $state, dateRangeTimeFiltersService: DateRangeTimeFiltersService, $stateParams, site) {
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType;

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Rule Engine"});
        triBreadcrumbsService.addCrumb({name: "Automations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    .state('rule', {
      parent: 'bringoz.site',
      url: '/rule/:id',
      abstract: true,
      template: '<ui-view class="full-height"></ui-view>',
      controller: function (rule, metadataSettings, $scope, site) {
        $scope.rule = rule;
        $scope.metadataSettings = metadataSettings
      },
      resolve: {
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        },
        rule: function ($rule: $ruleFactory, $stateParams, site) {
          return $rule($stateParams.id).$asyncValue();
        }
      }
    })

    //*** Edit Rule View **//
    .state('rule.edit', {
      url: '/edit',
      template: '<rule-view rule="vm.rule" events="vm.events" metadata-settings="vm.metadataSettings"></rule-view>',
      controllerAs: 'vm',
      controller: function (events, triBreadcrumbsService, rule,metadataSettings) {

        this.rule = angular.copy(rule);
        this.metadataSettings = metadataSettings;
        this.events = events;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Edit'});
        triBreadcrumbsService.addCrumb({name: "Rule Engine", state: 'rules.table'});
        triBreadcrumbsService.addCrumb({name: "Automations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        events: function (ruleEngineRequestsService: RuleEngineRequestsService, site) {
          return ruleEngineRequestsService.getEvents();
        }
      }
    })
    //*** Create Rule View **//
    .state('rule-create', {
      parent: 'bringoz.site',
      url: '/rule-create',
      controllerAs: 'vm',
      template: '<rule-view events="vm.events" metadata-settings="vm.metadataSettings"></rule-view>',
      controller: function (triBreadcrumbsService, events, site, $stateParams, metadataSettings) {

        this.events = events;
        this.metadataSettings = metadataSettings;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Create Rule"});
        triBreadcrumbsService.addCrumb({name: "Rule Engine", state: 'rules.table'});
        triBreadcrumbsService.addCrumb({name: "Automations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        events: function (ruleEngineRequestsService: RuleEngineRequestsService, site) {
          return ruleEngineRequestsService.getEvents();
        },
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })


}
